import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/Auth0ProviderWithHistory';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
